import React from "react";
import withStyles from "react-jss";
import classNames from "classnames";

const styles = (theme) => ({
	root: {
		textAlign: "center",
	},
	wrapper: {
		width: "100%",
		height: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	purpleButton: {
		width: "252px",
		height: "56px",
		fontFamily: theme.fonts.medium,
		color: theme.palette.colors.white,
		textTransform: "uppercase",
		fontSize: "16px",
		lineHeight: "1.22",
		letterSpacing: "1px",
		cursor: "pointer",
		backgroundColor: theme.palette.colors.purplishBlue,
		borderRadius: "10px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		textAlign: "center",
		userSelect: "none",
		"& a": {
			color: theme.palette.colors.white,
		},
	},
	icon: {
		width: "24px",
		height: "24px",
		marginTop: "5px",

		"& path": {
			fill: theme.palette.colors.darkSlateBlue,
		},
	},
	defaultCursor: {
		cursor: "default",
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		purpleButton: {
			width: "165px",
			fontSize: "14px",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		purpleButton: {
			width: "140px",
			fontSize: "12px",
			margin: "0 auto",
			lineHeight: "1.46",
		},
		icon: {
			width: "20px",
			height: "20px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			display: "flex",
			width: "100%",
		},
		purpleButton: {
			width: "100%",
			height: "52px",
			fontSize: "12px",
			borderRadius: "0 0 10px 10px",
			order: "3",
		},
		icon: {
			width: "20px",
			height: "20px",

			"& path": {
				fill: theme.palette.colors.purplishBlue,
			},
		},
	},
});

const ConnectButton = ({ classes, texts, connectURL, alt_text, defaultCursor, onClick, bn }) => {
	const buttonText = alt_text ? `${texts.connect} ${texts.CONNECT_OFFICIAL}` : texts.connect;

	const buttonInner = (
		<div>
			<div>{buttonText}</div>
		</div>
	);

	let buttonComponent = (
		<div
			className={classNames(classes.purpleButton, {
				[classes.defaultCursor]: defaultCursor,
			})}
			onClick={onClick}
		>
			{buttonInner}
		</div>
	);

	if (connectURL) {
		buttonComponent = (
			<a
				className={classNames(classes.purpleButton, {
					[classes.defaultCursor]: defaultCursor,
				})}
				href={connectURL}
				target="_blank"
				onClick={onClick}
				rel={bn ? "sponsored" : "noreferrer"}
			>
				{buttonInner}
			</a>
		);
	}
	return <div className={classNames([classes.root, classes.wrapper])}>{buttonComponent}</div>;
};

export default withStyles(styles)(ConnectButton);
